import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getOneDriveoAuthAccessTokenDataApi } from "../utils/Constants";


export const getOneDriveAccessToken = createAsyncThunk("getOneDriveAccessToken", async () => {
  try {
    const token = localStorage.getItem("token");

    const config = {
      headers: { Authorization: token, "Access-Control-Allow-Origin": "*" },
    };
    const response = await axios.get(ApiBaseUrl + getOneDriveoAuthAccessTokenDataApi, config);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
});

const GetOneDriveAccessTokenSlice = createSlice({
  name: "getOneDriveAccessTokenReducer",

  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearOneDriveAccessTokenData: (state) => {
      state.data = null;
      state.isAuthenticated = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOneDriveAccessToken.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getOneDriveAccessToken.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(getOneDriveAccessToken.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearOneDriveAccessTokenData } = GetOneDriveAccessTokenSlice.actions;
export default GetOneDriveAccessTokenSlice.reducer;
